import { useId, useState } from 'react';
import { cn } from '@/lib/infra/utils';

/** Shared by the live route and its populated visual fixture. The header
 * remains reachable while the activity scrolls. Size is local to this mount;
 * changing it never remounts the portal or its order/confirmation state. */
export function SelectedMarketActivity({ onHost }: { onHost: (host: HTMLDivElement | null) => void }) {
  const [expanded, setExpanded] = useState(false);
  const id = useId();
  return (
    <section aria-label="Selected market activity" className="bg-card border-border flex shrink-0 flex-col overflow-hidden rounded-lg border">
      <div className="border-border flex shrink-0 items-center justify-between gap-2 border-b px-4 py-1">
        <h2 className="text-[10px] font-semibold">Selected market activity</h2>
        <button
          type="button"
          className="text-primary rounded px-1 py-0.5 text-[11px] hover:bg-muted"
          aria-expanded={expanded}
          aria-controls={id}
          onClick={() => setExpanded((value) => !value)}
        >
          {expanded ? 'Less space' : 'More space'}
        </button>
      </div>
      <div
        id={id}
        ref={onHost}
        data-testid="game-detail-market-activity"
        className={cn(
          'min-h-0 overflow-y-auto [scrollbar-gutter:stable]',
          expanded ? 'max-h-[min(60vh,560px)]' : 'max-h-[min(32vh,300px)]',
        )}
      />
    </section>
  );
}
